import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const banner = new AxiosInterceptor();

export default {
  getAll(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return banner.get("/shop-banners?" + qstr);
  },
  getDetail(id) {
    return banner.get("/shop-banners/" + id);
  },
  create(inputs) {
    return banner.post("/shop-banners", inputs);
  },
  updateBanner(id, inputs) {
    return banner.put("/shop-banners/" + id, inputs);
  },
  deleteBanner(id) {
    return banner.delete("/shop-banners/" + id);
  },
  saveBanner(inputs) {
    return banner.put("/shop-banners/save", inputs);
  }
};
